import React from 'react';
import {
    Box,
    Button,
    Card,
    Chip,
    IconButton,
    Stack,
    Tooltip,
    Typography,
    useTheme,
} from "@mui/material";
import {
    ArrowForwardRounded,
    CancelRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const _SupportHeader = ({
    supportDetail,
    statusConfig,
    isClosed,
    onOpenCloseDialog,
    formatPersianDate,
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Card
            elevation={0}
            sx={{
                mb: 3,
                p: { xs: 2, sm: 3 },
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'flex-start', md: 'center' },
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }}>
                    <Tooltip title="بازگشت به لیست تیکت‌ها">
                        <IconButton
                            onClick={() => navigate('/support')}
                            sx={{
                                bgcolor: 'action.hover',
                                borderRadius: 3,
                                p: 1.2,
                                '&:hover': {
                                    bgcolor: 'action.hover',
                                },
                            }}
                        >
                            <ArrowForwardRounded />
                        </IconButton>
                    </Tooltip>

                    <Box sx={{ minWidth: 0 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mb: 0.5 }}>
                            <Typography variant="h5" sx={{ fontWeight: 800, color: 'text.primary' }}>
                                {supportDetail?.Title}
                            </Typography>
                            <Chip
                                size="small"
                                icon={statusConfig.icon}
                                label={statusConfig.label}
                                sx={{
                                    fontWeight: 700,
                                    height: 26,
                                    fontSize: '0.78rem',
                                    color: statusConfig.color,
                                    bgcolor: statusConfig.bgColor,
                                    border: '1px solid',
                                    borderColor: statusConfig.borderColor,
                                    '& .MuiChip-icon': {
                                        color: 'inherit',
                                    },
                                }}
                            />
                        </Box>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Typography variant="caption" color="text.secondary">
                                شناسه تیکت: <strong>#{supportDetail?.Id}</strong>
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                تاریخ ثبت: {formatPersianDate(supportDetail?.CreatedDate)}
                            </Typography>
                        </Stack>
                    </Box>
                </Box>

                {!isClosed && (
                    <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={onOpenCloseDialog}
                        startIcon={<CancelRounded />}
                        sx={{
                            borderRadius: 2.5,
                            fontWeight: 700,
                            px: 2,
                            alignSelf: { xs: 'stretch', sm: 'auto' },
                        }}
                    >
                        بستن / لغو تیکت
                    </Button>
                )}
            </Box>
        </Card>
    );
};

export default _SupportHeader;
